import {ukStyleDate} from '@peachy/utility-kit-pure'
import {Component} from 'solid-js'

export const InfoPanelNextPaymentDate: Component<{nextPaymentDate: number}> = (props) => {

    return (
        <p>Your next payment will be taken on <span>{ukStyleDate(new Date(props.nextPaymentDate))}</span></p>
    )
}
